import { get } from "frontend/utils/api"

let loadTestPromise = null

const getTestValueFromWindow = (testName) => {
  if (window.ab_tests[testName]) {
    return window.ab_tests[testName].value
  } else {
    return null
  }
}

const getFlagValueFromWindow = (flagName) => {
  if (flagName in window.feature_flags) {
    return window.feature_flags[flagName]
  } else {
    return null
  }
}

const loadTests = async () => {
  if (!loadTestPromise) {
    loadTestPromise = get("/ab_tests")
  }
  const result = await loadTestPromise

  if (result && result.status === 200) {
    window.feature_flags = result.data.feature_flags
    window.ab_tests = result.data.ab_tests
  } else {
    console.warn("Failed to load AB test assignments")
  }
}

export const getFlagValue = async (flagName) => {
  if (window.feature_flags) {
    return getFlagValueFromWindow(flagName)
  } else {
    await loadTests()
    return getFlagValueFromWindow(flagName)
  }
}

export const getTestValue = async (testName) => {
  if (window.ab_tests) {
    return getTestValueFromWindow(testName)
  } else {
    await loadTests()
    return getTestValueFromWindow(testName)
  }
}

export const getTests = async () => {
  if (window.ab_tests) {
    return window.ab_tests
  } else {
    await loadTests()
    return window.ab_tests
  }
}

export const getFlags = async () => {
  if (window.feature_flags) {
    return window.feature_flags
  } else {
    await loadTests()
    return window.feature_flags
  }
}
